import _ from 'lodash';
import moment from 'moment';
import { getDataFollowKeyByDot } from '../../../../helpers/Common';
import { keyBy } from 'lodash';
import reducerRegistry from '../../../../helpers/ReducerRegistry';
import {
  getPropertiesValues,
  convertExchange,
  getListRemoveDuplicate,
} from '../../../../helpers/ArrayUtils';
import strategyService from '../../../../../core/services/Strategy/StrategyService';
import Const from './Const';
import ConstValue from './Const';

const REDUCER_NAME = 'ST_VGM';
const SET_LOADING = `${REDUCER_NAME}SET_LOADING`;
const CHANGE_SIZE_COMPONENT = `${REDUCER_NAME}CHANGE_SIZE_COMPONENT`;
const HOVER_ROW = `${REDUCER_NAME}HOVER_ROW`;
const LOAD_MORE_ALL_VALUE = `${REDUCER_NAME}LOAD_MORE_ALL_VALUE`;
const FETCH_LOAD_LIST_ALL_VALUE = `${REDUCER_NAME}FETCH_LOAD_LIST_ALL_VALUE`;
const CHANGE_ALL_SCORE_LIST = `${REDUCER_NAME}CHANGE_ALL_SCORE_LIST`;
const LOAD_INVEST_DATA = `${REDUCER_NAME}LOAD_INVEST_DATA`;
const INIT_COMPONENT = `${REDUCER_NAME}INIT_COMPONENT`;
const UNMOUNT_COMPONENT = `${REDUCER_NAME}UNMOUNT_COMPONENT`;

export {
  REDUCER_NAME,
  reducer as default,
  intervalFetchAllValue,
  loadMoreAllValue,
  changeIndustryTableDropDown,
};

const initialState = {
  investData: {
    isFetching: true,
    valueInvestTable: [],
    valueInvestChart: [],
  },
  lstTickerIndustryDrop: [],
  lstTickerIndustryDropByTicker: [],
  listTickerAllValue: [],
  listAllValueByTicker: {},
  listAllValueByTickerOrg: {},
  listAllValueLoadMore: [],
  currentSelectedIndustryTable: ConstValue.itemAllIndustries,
  component: {},
  page: 1,
};

export const fetchValueInvestment = () => {
  return dispatch => {
    strategyService
      .getValueInvestment({ StrategyScoreType: 'VGM' })
      .then(response => {
        let { items = [] } = response === null ? [] : response || [];
        dispatch({
          type: LOAD_INVEST_DATA,
          payload: {
            investData: items && items.length ? items : [],
          },
        });
      });
  };
};

function changeIndustryTableDropDown(currentSelectedIndustryTable) {
  return dispatch => {
    const icbCode = currentSelectedIndustryTable.icbCode;

    dispatch(intervalFetchAllValue(true, { icbCode }));

    dispatch({
      type: CHANGE_ALL_SCORE_LIST,
      payload: {
        currentSelectedIndustryTable,
      },
    });
  };
}

function objectListAllValue(getState, value) {
  const store = getState();
  const obj = {
    listTickerAllValue: store[REDUCER_NAME].listTickerAllValue,
    listAllValueByTicker: store[REDUCER_NAME].listAllValueByTickerOrg,
    currentTabAllScore: store[REDUCER_NAME].currentTabAllScore,
    currentSelectedIndustryTable:
      store[REDUCER_NAME].currentSelectedIndustryTable,
  };
  let valueSelectedIndustry = value
    ? value
    : store[REDUCER_NAME].currentSelectedIndustryTable;
  valueSelectedIndustry = !_.isEmpty(valueSelectedIndustry)
    ? valueSelectedIndustry.icbCode === Const.icbCodeDefault
      ? {}
      : valueSelectedIndustry
    : {};
  obj.listIcbCode = getPropertiesValues(valueSelectedIndustry, 'icbCode');
  return obj;
}

function loadMoreAllValue(params) {
  return (dispatch, getState) => {
    dispatch(setLoading(true));
    const objLstAllScore = objectListAllValue(getState);
    const formatParams = formatedParams(params, false);
    const page = formatParams.Page;
    const scoreId = params.scoreId;
    const { icbCode } = getState()[REDUCER_NAME].currentSelectedIndustryTable;
    const optionalParams = {};
    optionalParams.IcbCode = icbCode === 'all' ? null : icbCode;
    strategyService
      .getVGM({ ...formatParams, ...optionalParams })
      .then(response => {
        let { items = [] } = response === null ? [] : response || [];
        const { totalCount = 0 } = response === null ? 0 : response || [];
        const totalPage = calcTotalPage(totalCount);
        convertExchange(items);
        dispatch({
          type: LOAD_MORE_ALL_VALUE,
          payload: {
            listAllValueLoadMore: items,
            scoreId,
            page,
            totalPage,
            ...objLstAllScore,
          },
        });
        dispatch(setLoading(false));
      });
  };
}

function intervalFetchAllValue(isReload, params) {
  return (dispatch, getState) => {
    dispatch(setLoading(true));
    const objLstAllScore = objectListAllValue(getState);
    // const formatParams = formatedParams({ Code: Const.industryId }, false);
    const formatParams = formatedParams(
      { Code: Const.industryId, ...params },
      false,
    );

    strategyService.getVGM(formatParams).then(response => {
      let { items = [] } = response === null ? [] : response || [];
      const { totalCount = 0 } = response === null ? 0 : response || [];
      const totalPage = calcTotalPage(totalCount);
      items = items ? items : [];
      convertExchange(items);
      dispatch({
        type: FETCH_LOAD_LIST_ALL_VALUE,
        payload: {
          ...objLstAllScore,
          listTickerAllValue: items || [],
          totalPage,
          isReload,
        },
      });
      dispatch(setLoading(false));
    });
  };
}

function setLoading(isLoading) {
  return dispatch => {
    dispatch({
      type: SET_LOADING,
      payload: isLoading,
    });
  };
}

function getDataFilterAllValue(payload) {
  let {
    listAllValueLoadMore,
    listTickerAllValue,
    listAllValueByTicker,
    isReload,
  } = payload;
  if (isReload) {
    listAllValueByTicker = {};
  }
  const lstTickerLoadMore = !_.isEmpty(listAllValueLoadMore)
    ? listAllValueLoadMore.map(item =>
        getDataFollowKeyByDot(item, Const.organCode),
      )
    : [];
  listAllValueByTicker = !_.isEmpty(listAllValueByTicker)
    ? listAllValueByTicker
    : keyBy(listTickerAllValue, Const.organCode);

  let lstTicker = !_.isEmpty(lstTickerLoadMore)
    ? [...listTickerAllValue, ...lstTickerLoadMore]
    : listTickerAllValue;
  let lstTickerLoadMoreByTicker = getListRemoveDuplicate(
    lstTicker,
    listAllValueLoadMore,
    Const.organCode,
  );
  let obj = {
    listAllValueByTickerOrg: {
      ...listAllValueByTicker,
      ...lstTickerLoadMoreByTicker,
    },
  };
  obj.lstTickerLoadMoreByTicker = keyBy(
    obj.listAllValueByTickerOrg,
    Const.organCode,
  );
  return obj;
}

function reducer(state = {}, action) {
  switch (action.type) {
    case INIT_COMPONENT:
      return {
        ...state,
        ...initialState,
      };

    case UNMOUNT_COMPONENT:
      return {};

    case LOAD_INVEST_DATA: {
      const { investData } = action.payload;
      const valueInvestTable = [...investData];
      const investDataLength = investData.length;
      const arr = [...Array(investDataLength)].map(
        (_, index) => investDataLength - (index + 1),
      );
      const valueInvestChart = investData.map((item, index) => {
        const currentYear = new Date().getFullYear();
        return {
          ...item,
          averageIndex: item.averageIndex + 1,
          averageStock: item.averageStock + 1,
          timeRange: currentYear - arr[index],
        };
      });
      return {
        ...state,
        investData: {
          ...state.investData,
          valueInvestTable,
          valueInvestChart,
          isFetching: false,
        },
      };
    }

    case FETCH_LOAD_LIST_ALL_VALUE: {
      const objLoadMore = getDataFilterAllValue(action.payload);
      const listTickerAllValue = _.keys(objLoadMore.lstTickerLoadMoreByTicker);
      return {
        ...state,
        listTickerAllValue,
        listAllValueByTicker: objLoadMore.lstTickerLoadMoreByTicker,
        listAllValueByTickerOrg: objLoadMore.listAllValueByTickerOrg,
        isLoading: false,
        page: 1,
      };
    }

    case LOAD_MORE_ALL_VALUE: {
      let { listAllValueLoadMore, totalPage, page } = action.payload;
      const objLoadMore = getDataFilterAllValue(action.payload);
      const lstTicker = _.keys(objLoadMore.lstTickerLoadMoreByTicker);
      return {
        ...state,
        listTickerAllValue: _.uniq(lstTicker),
        listAllValueByTicker: objLoadMore.lstTickerLoadMoreByTicker,
        listAllValueByTickerOrg: objLoadMore.listAllValueByTickerOrg,
        scoreId: _.last(lstTicker),
        firstPage: 0,
        listAllValueLoadMore,
        page,
        totalPage,
      };
    }

    case CHANGE_ALL_SCORE_LIST: {
      const { currentSelectedIndustryTable } = action.payload;
      return {
        ...state,
        currentSelectedIndustryTable,
        firstPage: 0,
      };
    }

    case HOVER_ROW: {
      return {
        ...state,
        organCodeHover: action.payload.organCode,
        currentItemSearch: action.payload.currentItemSearch,
      };
    }

    case SET_LOADING: {
      return { ...state, isLoading: action.payload };
    }

    case CHANGE_SIZE_COMPONENT:
      return {
        ...state,
        component: action.payload,
      };

    default:
      return state;
  }
}

function formatedParams(params, isRanking = true) {
  params = params || {};
  const formatParams = {
    Page: params.Page || 1,
    PageSize: Const.pageSize,
    time: moment().valueOf(),
    IcbCode: params.icbCode === 'all' ? null : params.icbCode,
  };
  if (isRanking) {
    if (params.Code) formatParams.Code = params.Code;
  }

  return formatParams;
}

const calcTotalPage = totalCount => {
  const totalPage = Math.ceil(totalCount / Const.pageSize);
  return totalPage || 0;
};

reducerRegistry.register(REDUCER_NAME, reducer);
